import { render, staticRenderFns } from "./wx-open-app.vue?vue&type=template&id=562a1b10&scoped=true&"
import script from "./wx-open-app.vue?vue&type=script&lang=js&"
export * from "./wx-open-app.vue?vue&type=script&lang=js&"
import style0 from "./wx-open-app.vue?vue&type=style&index=0&id=562a1b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a1b10",
  null
  
)

export default component.exports